import React, { useContext } from "react";
import { Link } from "react-router-dom";
import EssenceActionsDropdown from "../EssenceActionsDropdown";
import "../../../../sass/viewer.scss";
import EssenceStateLabel from "../EssenceStateLabel";
import Context from "../../../Context";
export default function TemplatesListRow(props) {
  const cx = useContext(Context);

  let values = [];
  for (let field in props) values.push(field);

  const classIcons = {
    instruction: "text-dark-50 fa fa-file-text-o",
    template: "text-dark-25 fa fa-file-code-o",
  };
  const classIcon = classIcons[props.classcode] || "fa fa-file-o";

  const onClick = (e) => {
    if (!e.ctrlKey && !e.shiftKey) {
      cx.redirect(`/manual/${props.structure}/${props.id}/`);
    }
    if (props.onItemClick) {
      props.onItemClick(e, props.listItemId);
    }
  };

  let selectedItems = Array.isArray(props.selectedItems)
    ? props.selectedItems
    : [];

  let itemClasses = "row py-4 border-bottom text-dark list-item cursor-pointer";
  itemClasses += props.highlightItem === String(props.id) ? " current" : "";
  itemClasses += selectedItems.includes(props.id) ? " active" : "";

  return (
    <>
      <div onClick={onClick} className={itemClasses}>
        <div
          style={{ wordBreak: "break-all" }}
          className="col-lg-10 m-lg-0 my-3"
        >
          <i title={props.classlabel} className={` mr-2 ${classIcon}`}></i>
          {props.label}
        </div>

        <div className="col-lg-2  d-flex align-items-center justify-content-end text-right">
          <EssenceStateLabel
            id={props.id}
            stateCode={props.statetypecode}
            stateLabel={props.statelabel}
            essence="manual"
          />

          <EssenceActionsDropdown
            className="px-2"
            essence={"manual"}
            key={props.id}
            id={props.id}
            label={props.label}
            onFinish={props.onFinish}
            attendantItems={props.selectedItems}
            onPending={props.onPending}
            onDrop={props.onDrop}
          />
        </div>
      </div>
    </>
  );
}
